import { WizardModel } from "@/shared/Wizard/models/WizardModel";
import { AnalysisWizardStep } from "./AnalysisWizardStep";
import { AnalysisWizardSharedModel } from "./AnaylsisWizardSharedModel";



export class AnalysisWizardModel extends WizardModel<AnalysisWizardStep, AnalysisWizardSharedModel> {
    
    public name: string = "Analysis Designer";

    constructor(steps: Array<AnalysisWizardStep> = []) {
        super();
        this.steps = steps;
    }
    
}